<template lang="pug">
  v-fade-transition(
    v-if="blockingProgression")
    v-overlay(
      :dark="!$theme.dark"
      :color="color"
      :opacity="1"
      absolute)
      v-progress-circular(
        v-if="$get(blockingProgression, `isActive`)"
        indeterminate)
</template>

<script>
import Chroma from 'chroma-js'
import { theme } from '@iez/core'
import { toRefs, computed } from '@vue/composition-api'
import { state } from '..'

export default {
  setup () {
    const defaultColor = `#212121`
    const chroma = Chroma(defaultColor)

    const darkColor = chroma
      .alpha(.46)
      .hex()
    const lightColor = chroma
      .set(`hsl.l`, 1 - chroma.get(`hsl.l`))
      .alpha(.46)
      .hex()

    const color = computed(
      () => theme.dark
        ? darkColor
        : lightColor
    )

    return {
      ...toRefs(state),
      color
    }
  }
}
</script>

<style scoped>
>>> .v-overlay__scrim {
  backdrop-filter: blur(4px);
}
</style>
